import { MDBCol, MDBRow } from 'mdbreact'
import React, { useState } from 'react'
import SubirImagenesContainer from '../../../SubirImagenes';
import { Image2, Search } from 'react-iconly';

const OpcionesTamanoChildren = (props) => {
    const { type, id, handleEstilosComponente, styles } = props;
    const [color, setColor] = useState(styles?.background)

    const [modal, setModal] = useState(false)
    const [urlImg, setUrlImg] = useState(styles?.backgroundUrl)

    const modificarModal = () => {
        setModal(!modal)
    }

    const imagenActual = (img) => {
        handleEstilosComponente({ type, id, valor: img.path, nombre: 'backgroundUrl' })
        setUrlImg(img.path)
        setModal(false)
    }

    return (
        <div>
            {props.children}
            <hr />
            <div className='mb-2'>
                <h4>Tamaño</h4>
                <MDBRow className='mb-2'>
                    <MDBCol>
                        <h6>Ancho</h6>
                        <input
                            defaultValue={styles?.width}
                            type="number"
                            className="form-control form-control-sm"
                            onChange={(e) => handleEstilosComponente({ type, id, valor: parseInt(e.target.value), nombre: 'width' })}
                        />
                    </MDBCol>
                    <MDBCol>
                        <h6>Alto</h6>
                        <input
                            defaultValue={styles?.height}
                            type="number"
                            className="form-control form-control-sm"
                            onChange={(e) => handleEstilosComponente({ type, id, valor: parseInt(e.target.value), nombre: 'height' })}
                        />
                    </MDBCol>
                </MDBRow>

                <div className='mb-2'>
                    <h4>Padding</h4>
                    <MDBRow>
                        <MDBCol >
                            <label>Arriba</label>
                            <input
                                defaultValue={styles?.paddingArriba}
                                type="number"
                                className="form-control form-control-sm"
                                onChange={(e) => handleEstilosComponente({ type, id, valor: parseInt(e.target.value), nombre: 'paddingArriba' })}
                            />
                        </MDBCol>
                        <MDBCol>
                            <label>Abajo</label>
                            <input
                                defaultValue={styles?.paddingAbajo}
                                type="number"
                                className="form-control form-control-sm"
                                onChange={(e) => handleEstilosComponente({ type, id, valor: parseInt(e.target.value), nombre: 'paddingAbajo' })}
                            />
                        </MDBCol>
                        <MDBCol>
                            <label>Derecha</label>
                            <input
                                defaultValue={styles?.paddingDerecha}
                                type="number"
                                className="form-control form-control-sm"
                                onChange={(e) => handleEstilosComponente({ type, id, valor: parseInt(e.target.value), nombre: 'paddingDerecha' })}
                            />
                        </MDBCol>
                        <MDBCol>
                            <label>Izquierda</label>
                            <input
                                defaultValue={styles?.paddingIzquierda}
                                type="number"
                                className="form-control form-control-sm"
                                onChange={(e) => handleEstilosComponente({ type, id, valor: parseInt(e.target.value), nombre: 'paddingIzquierda' })}
                            />
                        </MDBCol>

                    </MDBRow>
                </div>
                <div className='mb-2'>
                    <h4>Margen</h4>
                    <MDBRow>
                        <MDBCol>
                            <label>Arriba</label>
                            <input
                                defaultValue={styles?.marginArriba}
                                type="number"
                                className="form-control form-control-sm"
                                onChange={(e) => handleEstilosComponente({ type, id, valor: parseInt(e.target.value), nombre: 'marginArriba' })}
                            />
                        </MDBCol>
                        <MDBCol>
                            <label>Abajo</label>
                            <input
                                defaultValue={styles?.marginAbajo}
                                type="number"
                                className="form-control form-control-sm"
                                onChange={(e) => handleEstilosComponente({ type, id, valor: parseInt(e.target.value), nombre: 'marginAbajo' })}
                            />
                        </MDBCol>
                        <MDBCol>
                            <label>Derecha</label>
                            <input
                                defaultValue={styles?.marginDerecha}
                                type="number"
                                className="form-control form-control-sm"
                                onChange={(e) => handleEstilosComponente({ type, id, valor: parseInt(e.target.value), nombre: 'marginDerecha' })}
                            />
                        </MDBCol>
                        <MDBCol>
                            <label>Izquierda</label>
                            <input
                                defaultValue={styles?.marginIzquierda}
                                type="number"
                                className="form-control form-control-sm"
                                onChange={(e) => handleEstilosComponente({ type, id, valor: parseInt(e.target.value), nombre: 'marginIzquierda' })}
                            />
                        </MDBCol>
                    </MDBRow>
                </div>
            </div>

            <div className='mb-2'>
                <h4>Fondo</h4>
                <MDBRow className='mb-2'>
                    <MDBCol>
                        <h6>Color</h6>
                        <input
                            type="color"
                            id="exampleColorInput"
                            value={color}
                            onChange={(e) => { handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'background' }); setColor(e.target.value) }}
                            title="Choose your color"
                        />
                    </MDBCol>
                    <MDBCol>
                        <div className='d-flex align-items-cente mb-2'>
                            <h6 className='m-0'>Url Imagen</h6>
                            <a onClick={modificarModal}>
                                <Image2 className="ml-1" set="bold" />
                            </a>
                        </div>
                        <input
                            defaultValue={urlImg}
                            type="text"
                            disabled
                            className="form-control form-control-sm"
                            onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'backgroundUrl' })}
                        />
                    </MDBCol>
                </MDBRow>
            </div>
            <div className='mb-2'>
                <h4>Efectos</h4>
                <MDBRow className='mb-2'>
                    <MDBCol>
                        <div className="custom-control custom-checkbox" onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.checked, nombre: 'zoom' })}>
                            <input type="checkbox" className="custom-control-input" id="zoom" defaultChecked={styles?.zoom} />
                            <label className="custom-control-label" htmlFor="zoom">Zoom</label>
                        </div>
                    </MDBCol>
                    <MDBCol>
                        <div className="custom-control custom-checkbox" onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.checked, nombre: 'hoverDivClaro' })}>
                            <input type="checkbox" className="custom-control-input" id="hoverDivClaro" defaultChecked={styles?.hoverDivClaro} />
                            <label className="custom-control-label" htmlFor="hoverDivClaro">Hover Claro</label>
                        </div>
                    </MDBCol>

                </MDBRow>
                <MDBRow className='mb-2'>
                    <MDBCol>
                        <div className="custom-control custom-checkbox" onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.checked, nombre: 'hoverDivNegro' })}>
                            <input type="checkbox" className="custom-control-input" id="hoverDivNegro" defaultChecked={styles?.hoverDivNegro} />
                            <label className="custom-control-label" htmlFor="hoverDivNegro">Hover Oscuro</label>
                        </div>
                    </MDBCol>
                    <MDBCol>
                        <div className="custom-control custom-checkbox" onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.checked, nombre: 'hoverDivMorado' })}>
                            <input type="checkbox" className="custom-control-input" id="hoverDivMorado" defaultChecked={styles?.hoverDivMorado} />
                            <label className="custom-control-label" htmlFor="hoverDivMorado">Hover Morado</label>
                        </div>
                    </MDBCol>
                </MDBRow>
                <MDBRow className='mb-2'>
                    <MDBCol>
                        <div className="custom-control custom-checkbox" onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.checked, nombre: 'hoverDiv' })}>
                            <input type="checkbox" className="custom-control-input" id="hoverDiv" defaultChecked={styles?.hoverDiv} />
                            <label className="custom-control-label" htmlFor="hoverDiv">Hover</label>
                        </div>
                    </MDBCol>
                    <MDBCol>
                        <h6>Sombra</h6>
                        <input
                            defaultValue={styles?.shadows}
                            type="number"
                            placeholder='1 a 5'
                            min={0}
                            max={5}
                            className="form-control form-control-sm"
                            onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'shadows' })}
                        />
                    </MDBCol>
                </MDBRow>
                <MDBRow className='mb-2'>
                    <MDBCol md='6'>
                        <h6>Radio</h6>
                        <input
                            defaultValue={styles?.borderRadius}
                            type="number"
                            className="form-control form-control-sm"
                            onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'borderRadius' })}
                        />
                    </MDBCol>
                </MDBRow>
            </div>
            <div className='mb-2'>
                <h4>Clases CSS</h4>
                <MDBRow className='mb-2'>
                    <MDBCol>
                        <input
                            defaultValue={styles?.className}
                            type="text"
                            placeholder='Class CSS'
                            className="form-control form-control-sm"
                            onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'className' })}
                        />
                    </MDBCol>
                </MDBRow>
            </div>
            <SubirImagenesContainer modal={modal} imagenActual={imagenActual} modificarModal={modificarModal} />
        </div>
    )
}

export default OpcionesTamanoChildren